import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { ManagePracticeService } from 'src/app/manage-practice/manage-practice.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-counselors',
  templateUrl: './counselors.component.html',
  styleUrls: ['./counselors.component.css']
})
export class CounselorsComponent implements OnInit {

  title = "Counselors"
  counselors: any = [];
  constructor(
    private translateService: TranslateService,
    private loadingService: CustomLoadingService,
    private managePracticeService: ManagePracticeService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data: { counselors: any }) => {

      this.counselors = data.counselors;

    });
  }
  deleteCounselor(id) {
    if (confirm(this.translateService.instant("Common.DeleteConfirm"))) {
      this.loadingService.show();
      this.managePracticeService.deleteCounselor(id).subscribe(res => {
        document.getElementById("tr"+id).remove();
        this.loadingService.show();


      }, (error) => {
        
        this.loadingService.hide();

      }, () => { this.loadingService.hide(); })
    }
  }
}
